var _style, _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 42 45",
    style: {
      enableBackground: "new 0 0 42 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.pig{clip-path:url(#SVGID_2_);fill:#559BFB;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 1.5,
    width: 42,
    height: 42
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pig",
    d: "M26.5,25.7c-0.4-0.5-1-0.6-1.5-0.1l-1,1c-0.5,0.5-1.1,0.4-1.5-0.1l-4.1-5.3c-0.4-0.5-1-0.5-1.2,0.1l-4,8 c-0.3,0.6,0,1.1,0.6,1.1h14.8c0.7,0,0.9-0.4,0.5-1L26.5,25.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "pig",
    d: "M24.2,20.7c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4 C21.8,19.7,22.9,20.7,24.2,20.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "pig",
    d: "M21,1.5c-11.6,0-21,9.4-21,21c0,11.6,9.4,21,21,21s21-9.4,21-21C42,10.9,32.6,1.5,21,1.5 M31.8,30.2 c0,1.3-1.1,2.4-2.4,2.4H12.7c-1.3,0-2.4-1.1-2.4-2.4V14.8c0-1.3,1.1-2.4,2.4-2.4h16.7c1.3,0,2.4,1.1,2.4,2.4V30.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIg);
export default __webpack_public_path__ + "static/media/product-ig.dc8b2066876c7b79ae572048ebc7b4db.svg";
export { ForwardRef as ReactComponent };